import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { UpdatePasswordForm } from '@/features/auth/components/forms/update-password-form';
import { AuthLayout } from '@/features/auth/components/layouts/auth-layout';
import ChevronLeftIcon from '@/shared/assets/chevron-left.svg?react';
import { FlowLayoutBody } from '@/shared/components/flow/flow-layout';

export const UpdatePasswordPage = () => {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const isFromSettings = searchParams.get('from') === 'settings';

  return (
    <AuthLayout
      title="Update Password"
      headerActions={[
        {
          label: isFromSettings
            ? t('UpdatePasswordPage.back_to_settings_label')
            : t('ResetPasswordPage.login_link_label'),
          href: isFromSettings
            ? paths.settings.getHref()
            : paths.auth.login.getHref(),
          icon: <ChevronLeftIcon />,
        },
      ]}
    >
      <FlowLayoutBody>
        <UpdatePasswordForm isFromSettings={isFromSettings} />
      </FlowLayoutBody>
    </AuthLayout>
  );
};
